import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import './SidebarMenu.scss';
import PropTypes from 'prop-types';
import actions from '../../../../redux/actions';
import {useHistory} from 'react-router-dom';
import NewAttention from '../../../../assets/icons/NewAttention';
import SideBarButton from '../../SideBarButton/SideBarButton';
import AttentionsHistory from '../../../../assets/icons/AttentionsHistory';
import Admin from '../../../../assets/icons/Admin';
import Users from '../../../../assets/icons/Users';
import AffiliateSearch from '../../../../assets/icons/AffiliateSearch';
import ValuesGrid from '../../../../assets/icons/ValuesGrid';
import Config from '../../../../assets/icons/Config';
import Logout from '../../../../assets/icons/Logout';
import DoubleArrowBack from '../../../../assets/icons/DoubleArrowBack';
import DoubleArrowForward from '../../../../assets/icons/DoubleArrowForward';
import _ModalSideBar from './SideModalManual';
import Performance from '../../../../assets/icons/Performance';
import Key from '../../../../assets/icons/Key';


const adminOptions = [
    // {name: 'Inicio', route: '/home'},
    {
        name: 'Nueva atención',
        route: '/createAttention',
        description: 'Registrar nuevas atenciones.',
        selected: false,
        icon: <NewAttention width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <NewAttention width={'14'} height={'14'} color={'primary-500'}/>,
    },
    {
        name: 'Historial',
        route: '/attentionsHistory',
        description: 'Historial de atenciones',
        selected: false,
        icon: <AttentionsHistory width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <AttentionsHistory width={'14'} height={'14'} color={'primary-500'}/>,
    },
    {
        name: 'Consulta de cobertura',
        route: '/affiliates',
        selected: false,
        icon: <AffiliateSearch width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <AffiliateSearch width={'14'} height={'14'} color={'primary-500'}/>,
    },
    {
        name: 'Administradores',
        route: '/administrators',
        selected: false,
        icon: <Admin width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <Admin width={'14'} height={'14'} color={'primary-500'}/>,
    },
    {
        name: 'Usuarios de Prestadores',
        route: '/providerUsers',
        selected: false,
        icon: <Users width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <Users width={'14'} height={'14'} color={'primary-500'}/>,
    },
    {
        name: 'Grilla de valores',
        route: '/amountList',
        selected: false,
        icon: <ValuesGrid color={'#6E6C6C'}/>,
        selectedIcon: <ValuesGrid color={'primary-500'}/>,
    },
    {
        name: 'Performance',
        route: '/performance',
        description: 'Test API performance and measure response times.',
        selected: false,
        icon: <Performance width={'14'} height={'14'} color={'#6E6C6C'}/>,
        selectedIcon: <Performance width={'14'} height={'14'} color={'#005DAA'}/>,
    },
    // {name: 'Historial', route: '/attentionsList'},
    // {name: 'Cobertura', route: '/plans/list',
    //     description: 'Información acerca de la cobertura de nuestros planes.', component: (data) => tooltip(data)},
    // {name: 'Consulta de afiliados', route: '/affiliates',
    //     description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
    // {name: 'Administradores', route: '/admin/list'},
    // {name: 'Usuarios de Prestadores', route: '/provider/list'},
    // {name: 'Grilla de valores', route: '/amount/list'},
];
const manualDeUsoOption = {
    name: 'Manual de Uso',
    selected: false,
    description: 'Consulta el manual de usuario.',
    icon: <Users color={'#6E6C6C'}/>,
    selectedIcon: <Config color={'primary-500'} />,
    onClick: () => _ModalSideBar.show(),
};

const AUTO_OPEN_MANUAL_ROLES = ['PROVIDER_ADMIN', 'PROVIDER_USER'];
const AUTO_OPEN_MANUAL_KEY_PREFIX = 'manualDeUso:autoSeen:';

const canAutoOpenManual = (roleName) => AUTO_OPEN_MANUAL_ROLES.includes(roleName);

const getLocalDayKey = (date = new Date()) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const getStoredManualDayKey = (storedValue) => {
    if (!storedValue) {
        return null;
    }

    const parsedDate = new Date(storedValue);

    if (Number.isNaN(parsedDate.getTime())) {
        return storedValue;
    }

    return getLocalDayKey(parsedDate);
};

const hasSeenManualToday = (storageKey) => {
    const lastSeenAt = localStorage.getItem(storageKey);

    return getStoredManualDayKey(lastSeenAt) === getLocalDayKey();
};

const markManualAsSeen = (storageKey) => {
    if (!storageKey) {
        return;
    }

    localStorage.setItem(storageKey, new Date().toISOString());
};

const getAutoOpenManualKey = (userInfo) => {
    const userIdentifier = userInfo?.id || userInfo?.email;

    if (!userIdentifier) {
        return null;
    }

    return `${AUTO_OPEN_MANUAL_KEY_PREFIX}${userIdentifier}`;
};

const providerUserOptions = [
    // {name: 'Inicio', route: '/home'},
    // {name: 'Historial atenciones', route: '/attentionsList'},
    // {name: 'Atenciones', route: '/newMedicalService'},
    // {name: 'Planes', route: '/plans/list'},
    manualDeUsoOption,
    {
        name: 'Consulta de cobertura',
        route: '/affiliates',
        selected: false,
        icon: <AffiliateSearch color={'#6E6C6C'}/>,
        selectedIcon: <AffiliateSearch color={'primary-500'}/>,
    },
];

const providerUserOptionsFf = [
    // {name: 'Inicio', route: '/home'},
    manualDeUsoOption,
    {
        name: 'Nueva atención',
        route: '/createAttention',
        description: 'Registrar nuevas atenciones.',
        selected: false,
        icon: <NewAttention color={'#6E6C6C'}/>,
        selectedIcon: <NewAttention color={'primary-500'}/>,
    },
    {
        name: 'Historial',
        route: '/attentionsHistory',
        description: 'Historial de atenciones',
        selected: false,
        icon: <AttentionsHistory color={'#6E6C6C'}/>,
        selectedIcon: <AttentionsHistory color={'primary-500'}/>,
    },
    {
        name: 'Consulta de cobertura',
        route: '/affiliates',
        selected: false,
        icon: <AffiliateSearch color={'#6E6C6C'}/>,
        selectedIcon: <AffiliateSearch color={'primary-500'}/>,
    },
];

const providerAdminOptionsFf = [
    manualDeUsoOption,
    {
        name: 'Nueva atención',
        route: '/createAttention',
        description: 'Registrar nuevas atenciones.',
        selected: false,
        icon: <NewAttention color={'#6E6C6C'}/>,
        selectedIcon: <NewAttention color={'primary-500'}/>,
    },
    {
        name: 'Historial',
        route: '/attentionsHistory',
        description: 'Historial de atenciones',
        selected: false,
        icon: <AttentionsHistory color={'#6E6C6C'}/>,
        selectedIcon: <AttentionsHistory color={'primary-500'}/>,
    },
    {
        name: 'Consulta de cobertura',
        route: '/affiliates',
        selected: false,
        icon: <AffiliateSearch color={'#6E6C6C'}/>,
        selectedIcon: <AffiliateSearch color={'primary-500'}/>,
    },
    {
        name: 'Usuarios de sede',
        route: '/providerUsers',
        selected: false,
        icon: <Users color={'#6E6C6C'}/>,
        selectedIcon: <Users color={'primary-500'}/>,
    },
    {
        name: 'Grilla de valores',
        route: '/amountList',
        selected: false,
        icon: <ValuesGrid color={'#6E6C6C'}/>,
        selectedIcon: <ValuesGrid color={'primary-500'}/>,
    },
];

const developerOptions = [
    {
        name: 'API',
        route: '/api',
        description: 'Credenciales para integrarse con la API.',
        selected: false,
        icon: <Key color={'#6E6C6C'}/>,
        selectedIcon: <Key color={'primary-500'}/>,
    },
];

const providerUserViewerOptions = [
    {
        name: 'Consulta de cobertura',
        route: '/affiliates',
        selected: false,
        icon: <AffiliateSearch color={'#6E6C6C'}/>,
        selectedIcon: <AffiliateSearch color={'#005DAA'}/>,
    },
];

const personalOptions = [
    {
        name: 'Mis Datos',
        route: '/config',
        selected: false,
        icon: <Config/>,
        selectedIcon: <Config color={'primary-500'}/>,
    },
    {
        name: 'Cerrar Sesión',
        route: '',
        selected: false,
        icon: <Logout/>,
        selectedIcon: <Logout color={'primary-500'}/>,
    },
];

const _SidebarMenu = (props) => {
    const {
        content,
        switchOfUser,
        logout,
        userInfo,
        showSidebar,
        cleanGetAffiliatesState,
        cleanAffiliates,
        toggleSidebar,
    } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [options, setOptions] = useState([]);
    const hasCheckedAutoOpenModal = useRef(false);
    const history = useHistory();
    const roleName = userInfo?.role?.name;
    const autoOpenManualKey = getAutoOpenManualKey(userInfo);
    const openManualModal = () => {
        markManualAsSeen(autoOpenManualKey);
        setIsModalVisible(true);
    };

    useEffect(() => {
        content && setOptions(content);
        switch (roleName) {
            case 'ADMIN':
                setOptions(adminOptions);
                break;
            case 'PROVIDER_ADMIN':
                setOptions(providerAdminOptionsFf);
                break;
            case 'PROVIDER_USER':
                setOptions(providerUserOptionsFf);
                break;
            case 'PROVIDER_USER_QUOTER':
            case 'PROVIDER_USER_VIEWER':
                setOptions(providerUserViewerOptions);
                break;
            case 'DEVELOPER':
                setOptions(developerOptions);
                break;
            default:
                setOptions(providerUserOptions);
                break;
        }
        // eslint-disable-next-line
    }, [content, roleName]);

    useEffect(() => {
        if (hasCheckedAutoOpenModal.current || !roleName) {
            return;
        }

        if (!canAutoOpenManual(roleName)) {
            hasCheckedAutoOpenModal.current = true;
            return;
        }

        if (!autoOpenManualKey) {
            return;
        }

        if (!hasSeenManualToday(autoOpenManualKey)) {
            markManualAsSeen(autoOpenManualKey);
            setIsModalVisible(true);
        }

        hasCheckedAutoOpenModal.current = true;
    }, [autoOpenManualKey, roleName]);

    const resetInfo = () => {
        cleanGetAffiliatesState();
        cleanAffiliates();
    };

    const pushPage = (name, route) => {
        if (name === 'Cerrar Sesión') {
            history.replace('/login');
            logout();
            return;
        }
        // This function is called because if not the affiliate info is not cleaned when changing from affiliates to createAttention
        resetInfo();
        switchOfUser(name);
        history.push(route);
        options.map((option) => option.name === name ? option.selected = true : option.selected = false);
    };

    const currentRoute = history.location.pathname;

    return (
        <div className={`v2-side-bar-container ${showSidebar ? '' : 'hidden'}`}>
            <div className="v2-side-bar-buttons-container">
                {
                    options && options.map((item, index) => {
                        return (
                            <SideBarButton key={`${item.name}-${index}`} onlyIcon={!showSidebar}
                            onClick={() => {
                                if (item.name === 'Manual de Uso') {
                                    openManualModal();
                                } else {
                                    pushPage(item.name, item.route);
                                }
                            }}
                            name={item.name}
                            icon={item.selected || currentRoute === item.route ? item.selectedIcon : item.icon}
                            index={index} selected={item.selected || currentRoute === item.route}/>
                        );
                    })
                }
            </div>
            <div className={'double-arrow-back-container'} onClick={() => toggleSidebar()}>
                {showSidebar ?
                    <DoubleArrowBack/> :
                    <DoubleArrowForward/>}
            </div>
                <div className="v2-side-bar-personal-buttons-container">
                    {personalOptions.map((item, index) => {
                        return (
                            <SideBarButton key={`${item.name}-${index}`} onlyIcon={!showSidebar} name={item.name}
                                           onClick={() => pushPage(item.name, item.route)}
                                           icon={item.selected || currentRoute === item.route ? item.selectedIcon : item.icon}
                                           index={index} selected={item.selected || currentRoute === item.route}/>
                        );
                    })}
                </div>
                {_ModalSideBar && ( <_ModalSideBar isOpen={isModalVisible} onClose={() => setIsModalVisible(false)}/>
                )}
            </div>
            );
            };

const mapStateToProps = (state) => ({
    title: state.home.title,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    logout: () => dispatch(actions.login.logout()),
    cleanGetAffiliatesState: () => dispatch(actions.home.cleanGetAffiliatesState()),
    cleanAffiliates: () => dispatch(actions.home.cleanAffiliates()),
    toggleSidebar: () => dispatch(actions.common.toggleSideBar()),
});

_SidebarMenu.propTypes = {
    content: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(_SidebarMenu);
